import React from 'react'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import Skeleton from '@mui/material/Skeleton'
import TableRow from '@mui/material/TableRow'

const TableBodyLoading = ({ id, columns, rowsPerPage }) => {
  return (
    <TableBody key={`table-body-loading-${id}`}>
      { [...Array(rowsPerPage).keys()].map((index) => (
        <TableRow key={`row-loading-${index}`}>
          {
            columns.map((column) => (
              <TableCell key={`table-body-loading-${id}-${column.key}-${index}`}>
                <div className='p-1'>
                  <Skeleton variant="text"  />
                </div>
              </TableCell>
            ))
          }
        </TableRow>
      ))}
    </TableBody>
  )
}

export default TableBodyLoading